import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { useLocation } from 'react-router-dom'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import Fade from 'embla-carousel-fade'
import Autoplay from 'embla-carousel-autoplay'

import styles from './hotspot.css'
import HOTSPOT_COMPONENT_FRAGMENT from '../../../graphql/fragments/hotspot-component.gql'
import { useIsAuthenticated } from '../../hooks/use-is-authenticated'
import { useScreenWidth } from '../../hooks/use-screen-width'
import {
  HOTSPOT_CAROUSEL_AUTOPLAY_DEFAULT_INTERVAL_MS,
  SCREEN_SIZE_BREAKPOINTS
} from '../../constants'
import EmblaCarouselForHotspot from '../emblaCarousel/emblaCarouselForHotspot'

function Hotspot({
  hotspot,
  isContentItemOnMyList,
  addToMyList,
  hasTopgradient
}) {
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()
  const screenWidth = useScreenWidth()

  // Determine if the user is on the guest home page
  const isGuestHome = !isAuthenticated && location.pathname === '/'

  // Modify slides if the user is on the guest home page
  const slides = isGuestHome ? hotspot.slides.slice(0, 1) : hotspot.slides
  if (!slides || !slides.length) {
    return null
  }

  // Configure hotspot carousel data and plugin behavior based on screen width.
  const rentalInfo = slides.map(slide => slide.contentItem.isRental)
  const interval = hotspot.uiConfig.interval || HOTSPOT_CAROUSEL_AUTOPLAY_DEFAULT_INTERVAL_MS
  const isMobileView = screenWidth <= SCREEN_SIZE_BREAKPOINTS.MIN_480
  const hotspotCarouselBasePlugins = isMobileView
    ? [
      WheelGesturesPlugin({ forceWheelAxis: 'x' }),
      Fade()
    ]
    : [Fade()]
  // Only enable autoplay if there are multiple slides to show
  const autoplayPlugin = slides.length > 1
    ? Autoplay({
      delay: interval,
      stopOnInteraction: false
    })
    : null
  const hotspotCarouselPlugins = autoplayPlugin
    ? [...hotspotCarouselBasePlugins, autoplayPlugin]
    : hotspotCarouselBasePlugins
  const hotspotCarouselOptions = {
    loop: true,
    align: 'start',
    containScroll: 'trimSnaps',
    duration: isMobileView ? 0 : 50, // Higher numbers enables slower scrolling
    watchDrag: () => isMobileView
  }

  return (
    <div className={styles.hotspotComponentWrapper}>
      <EmblaCarouselForHotspot
        slides={slides}
        options={hotspotCarouselOptions}
        plugins={hotspotCarouselPlugins}
        slideInfo={{
          isContentItemOnMyList,
          addToMyList,
          hasTopgradient,
          isGuestHome,
          rentalInfo,
          interval
        }}
        isHotspot
      />
    </div>
  )
}

Hotspot.propTypes = {
  hotspot: propType(HOTSPOT_COMPONENT_FRAGMENT).isRequired,
  isContentItemOnMyList: PropTypes.func.isRequired,
  addToMyList: PropTypes.func.isRequired,
  hasTopgradient: PropTypes.bool.isRequired
}

export default Hotspot
